<template>
  <v-container fluid class="ma-0 pa-0 mb-4">
    <v-row>
      <v-col cols="12" md="12">
        <el-switch
          class="mb-0"
          :classP="showIstorija ? 'strong-label' : ''"
          :label="$t('Veiksmų istorija')"
          v-model="showIstorija"
        />
      </v-col>
      <v-col cols="12" md="12" class="mb-4" v-if="showIstorija">
        <prasymas-istorija-busena />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PrasymasIstorijaBusena from './PrasymasIstorijaBusena'

export default {
  name: 'PrasymasIstorija',
  components: {
    PrasymasIstorijaBusena,
  },
  data() {
    return {
      showIstorija: false,
    }
  },
}
</script>
